import { gql } from '@apollo/client';

export default gql`
  subscription publishReadNotificationsArchivedSubscription($userId: String!) {
    publishReadNotificationsArchivedSubscription(userId: $userId) {
      userId
    }
  }
`;
